import React from 'react';

import {Box} from '@mui/material';
import Autoplay from 'embla-carousel-autoplay';
import {Carousel} from 'presentation/components';
import {CarrouselTypeEnum} from 'presentation/constants/carrouselTypeEnum';

import {ContentCollectionListEnum} from 'domain/usecases/private/content/post-content';
import {useHostName} from 'presentation/hooks';
import {useContentQuery} from 'presentation/queries/useContentQuery';
import {BannersLoading} from './components/BannersLoading';
import {StyledImage, StyledLink} from './styles';

export function BannersMyHospitalizationHome() {
	const {
		dataHostNameState: {productCode},
	} = useHostName();

	const {
		data: banners,
		isError,
		isLoading,
	} = useContentQuery({
		lista_colection: [ContentCollectionListEnum.MY_HOSPITALIZATION],
		numero_item: 3,
		operadora: productCode && productCode.length > 0 ? productCode[0].toString() : '',
	});

	if (isError) {
		return null;
	}

	if (isLoading) {
		return <BannersLoading />;
	}

	const isEmpty = !banners || banners?.listaConteudos.length === 0;

	return isEmpty ? null : (
		<Box>
			<Carousel
				type={CarrouselTypeEnum.DOTS}
				plugins={[Autoplay({stopOnInteraction: false})]}
				isFullscreen
				slides={banners?.listaConteudos.map((banner, index) => (
					<StyledLink
						key={index}
						href={banner.URL}
						target="_blank"
						rel="noreferrer noopener">
						<StyledImage
							src={banner?.campos?.minhaInternacao?.bannerPortal ?? ''}
							alt={banner?.campos?.minhaInternacao?.bannerPortal_alt ?? ''}
						/>
					</StyledLink>
				))}
			/>
		</Box>
	);
}
